// A Showcase picker sends explicit item intent. Legacy consumers retain array saves.
export async function commitPickerAdd({ product, existing = [], onAddProduct, replaceProducts }) {
  if (onAddProduct) return onAddProduct(product);
  return replaceProducts([...existing, product]);
}

export async function commitPickerRemove({ product, remaining = [], onRemoveProduct, replaceProducts }) {
  if (onRemoveProduct) return onRemoveProduct(product);
  return replaceProducts(remaining);
}
